
































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import LinkButton from '@/components/LinkButton.vue';
import { QuoteMixin, UserMixin, PriceMixin } from '@/Mixin';
import { format } from 'date-fns';
import QuoteMovieViewItem from '@/components/QuoteMovieViewItem.vue';
import TermsCompareItem from '@/components/TermsCompareItem.vue';
import {
  QuoteMovie,
  Quote,
  QuoteMovieFormat,
  QuoteMovieProvisionFormat,
  QuoteMovieProvisionLanguage,
} from '../../../store/types';
import {
  video_type,
  movie_resolution,
  frame_rate,
  aspect_ratio,
  video_format,
  audio_format,
  subtitle_file_format,
  right_name,
  right_holdback_length,
} from '@/components/const/SelectMovieOptions';
import { mapGetters } from 'vuex';
import NoticeModal from '@/components/NoticeModal.vue';

@Component({
  components: {
    LinkButton,
    QuoteMovieViewItem,
    TermsCompareItem,
    NoticeModal,
  },
  mixins: [QuoteMixin, UserMixin, PriceMixin],
})
export default class ProviderNegotiationsTerms extends Vue {
  quote?: Quote = null;
  quoteMovies?: Array<QuoteMovie> = null;
  isPurchasing: boolean = false;
  isCancelling: boolean = false;
  successFailMessage: string = '';
  plannedDeleteIndex: number = -1;
  isQuoteSet: boolean = false;
  translatedMessage?: string = null;

  mgDuration: Array<string> = ['pages.commons.quotes.contract_month', 'pages.commons.quotes.contract_whole_contract'];

  get currency() {
    if ((this as any).loginUserRole === 'provider') {
      return 'JPY';
    } else {
      return this.quote.currency;
    }
  }

  get videoType() {
    return video_type;
  }
  get movieResolution() {
    return movie_resolution;
  }
  get frameRate() {
    return frame_rate;
  }
  get aspectRatio() {
    return aspect_ratio;
  }
  get videoFormat() {
    return video_format;
  }
  get audioFormat() {
    return audio_format;
  }
  get subtitleFileFormat() {
    return subtitle_file_format;
  }
  get rightName() {
    return right_name;
  }
  get rightHoldbackLength() {
    return right_holdback_length;
  }

  revenuePercent(quoteMovie: QuoteMovie) {
    if ((this as any).loginUserRole === 'provider') {
      return (this.quote.revenue_percent * (100 - quoteMovie.fee_rate)) / 100;
    } else {
      return this.quote.revenue_percent;
    }
  }

  qmRevenuePercent(quoteMovie: QuoteMovie) {
    if ((this as any).loginUserRole === 'provider') {
      return (quoteMovie.revenue_percent * (100 - quoteMovie.fee_rate)) / 100;
    } else {
      return quoteMovie.revenue_percent;
    }
  }

  get vodRequestTitle() {
    if ((this as any).loginUserRole === 'consumer') {
      return this.$t('pages.commons.quotes.vod_request_title_consumer') as string;
    } else {
      return this.$t('pages.commons.quotes.vod_request_title_provider') as string;
    }
  }

  get chResponseTitle() {
    if ((this as any).loginUserRole === 'consumer') {
      return this.$t('pages.commons.quotes.ch_response_title_consumer') as string;
    } else {
      return this.$t('pages.commons.quotes.ch_response_title_provider') as string;
    }
  }

  get quoteTitle() {
    if (this.isQuoteSet) {
      return (this.quote as any).set_name;
    } else {
      return this.$t(`pages.commons.quotes.${(this as any).quoteState(this.quote, (this as any).loginUserRole)}`);
    }
  }

  get displayTrash() {
    const impersonateRole = (this as any).impersonatedRole;
    return !this.isQuoteSet && impersonateRole && impersonateRole == 'consumer';
  }
  get isQuoteCanncel() {
    return (
      (this.plannedDeleteIndex > -1 &&
        this.quoteMovies?.[this.plannedDeleteIndex] &&
        this.quoteMovies[this.plannedDeleteIndex].status > 1) ||
      (this.plannedDeleteIndex === -1 && this.quote && this.quote.status > 1)
    );
  }
  get quoteDeleteTitle() {
    return '見積もり依頼の' + (this.isQuoteCanncel ? 'キャンセル' : '削除');
  }
  get quoteDeleteContents() {
    let contentsText =
      this.plannedDeleteIndex > -1 ? `映画「${this.quoteMovies[this.plannedDeleteIndex].movie.film_name}」の` : '';
    contentsText += '見積もり依頼を' + (this.isQuoteCanncel ? 'キャンセルします。' : '削除します。');
    if (this.plannedDeleteIndex === -1 && this.quote && this.quote.status < 2) {
      contentsText += '完全に削除し、復元できませんがよろしいですか？';
    }
    return contentsText;
  }
  mounted() {
    if (this.$route.params.quote_id) {
      this.loadQuote();
    } else {
      this.loadQuoteSet();
    }
  }
  loadQuote() {
    if (!this.$route.params.quote_id) {
      return;
    }
    let uuid = this.$route.params.quote_id;

    this.axios
      .get(`/quote/${uuid}`)
      .then((result: any) => {
        this.$set(this, 'quote', result.data.data);
        let tmp = [];
        this.quote.movies.forEach((quoteMovie: any) => {
          tmp.push(this.axios.get(`/quote_movie/${quoteMovie.uuid}`));
        });
        return Promise.all(tmp);
      })
      .then((results: any) => {
        let tmp: Array<QuoteMovie> = results.map((result: any) => {
          return result.data.data;
        });
        this.$set(this, 'quoteMovies', tmp);
        if (this.quote.message && this.quote.message.length) {
          return this.axios.post('/translation', {
            text: this.quote.message,
            translate_from: 'en',
            translate_to: 'ja',
          });
        } else {
          return null;
        }
      })
      .then((result: any) => {
        if (result) {
          if (result.status !== 200) {
            throw new Error(`unable to translate quote message for quote ${this.quote.uuid}`);
          }
          this.translatedMessage = result.data.text;
        }
      })
      .catch((error: any) => {
        console.log(error);
      });
  }
  loadQuoteSet() {
    if (!this.$route.params.quote_set_id) {
      return;
    }
    this.$set(this, 'isQuoteSet', true);
    let uuid = this.$route.params.quote_set_id;
    this.axios
      .get(`/quote_set/${uuid}`)
      .then((result: any) => {
        this.$set(this, 'quote', result.data.data);
        let quoteMovie = new QuoteMovie();
        if (this.quote.formats.length > 0) {
          quoteMovie.formats = this.quote.formats.map((format: any) => {
            return new QuoteMovieProvisionFormat(format.uuid, format.video_type);
          });
        }
        if (this.quote.languages.length > 0) {
          quoteMovie.languages = this.quote.languages.map((language: any) => {
            return new QuoteMovieProvisionLanguage(language);
          });
        }

        this.$set(this, 'quoteMovies', [quoteMovie]);
      })
      .catch((error: any) => {
        console.log(error);
      });
  }
  channelNamesFromChannels(channels: Array<any>) {
    if (!channels || channels.length === 0) {
      return '';
    }
    const joinString = this.$i18n.locale === 'ja' ? '、' : ', ';
    return channels
      .map((channel) => {
        return `${channel.name} [${channel.url}]`;
      })
      .join(joinString);
  }
  hasDiff(index: number) {
    return true;
  }

  get allDeleteTitle() {
    if (!this.quote) {
      return '';
    }
    if (this.quote.status < 2) {
      return this.$t('pages.commons.quotes.deletedQuote');
    } else {
      return this.$t('pages.commons.quotes.cancelledQuote');
    }
  }

  async purchaseMovies() {
    this.isPurchasing = true;

    let quoteUuid = this.$route.params.quote_id;

    try {
      for (let qm of this.quoteMovies) {
        if (qm.status !== 8) {
          let result = await this.axios.put(`/quote_movie/${qm.uuid}`, { status: 5 });
          if (result.status !== 200) {
            throw `failed to change state for quote_movie ${qm.uuid} in consumer negotiationTerms`;
          }
          const index = this.quoteMovies.indexOf(qm);
          this.$set(this.quoteMovies, index, result.data.data);
        }
      }

      let result = await this.axios.put(`/quote/${quoteUuid}`, { status: 5 });
      if (result.status !== 200) {
        throw `failed to change state for quote ${quoteUuid} in consumer negotiationsTerms`;
      }
      this.$set(this, 'quote', result.data.data);

      this.successFailMessage = 'Successfully purchased.';
      this.$modal.show('successFailModal');
      this.isPurchasing = false;
    } catch (error) {
      console.log(error);
      this.isPurchasing = false;
      this.successFailMessage = 'Failed to purchase. Please try again.';
      this.$modal.show('successFailModal');
    }

    // tasks.push(this.axios.put(`/quote/${quoteUuid}`, { status: 5 }));
    // this.quoteMovies.map(qm => {
    //   if (qm.status !== 8) {
    //     tasks.push(this.axios.put(`/quote_movie/${qm.uuid}`, { status: 5 }));
    //   }
    // });

    // Promise.all(tasks)
    //   .then((results: Array<any>) => {
    //     let failed = results.find((result: any) => {
    //       return result.status !== 200;
    //     });
    //     if (failed === undefined) {
    //       this.successFailMessage = 'Successfully purchased.';
    //     } else {
    //       this.successFailMessage = 'Failed to purchase. Please try again.';
    //     }
    //       this.successFailMessage = 'Successfully purchased.';
    //     this.$modal.show('successFailModal');
    //     this.isPurchasing = false;
    //   })
    //   .catch((error: any) => {
    //     console.log(error);
    //     this.isPurchasing = false;
    //     this.successFailMessage = 'Failed to purchase. Please try again.';
    //     this.$modal.show('successFailModal');
    //   });
  }

  cancelMovies() {
    this.isCancelling = true;
    let quoteUuid = this.$route.params.quote_id;
    let tasks = [];

    this.axios
      .put(`/quote/${quoteUuid}`, { status: 8 })
      .then((result: any) => {
        if (result.status !== 200) {
          this.successFailMessage = this.$t('pages.commons.quotes.cancel_fail') as string;
          this.$modal.show('successFailModal');
          this.isCancelling = false;
          return false;
        }
        this.successFailMessage = this.$t('pages.commons.quotes.cancel_success') as string;
        this.$modal.show('successFailModal');
        this.isCancelling = false;
        this.loadQuote();
      })
      .catch((error: any) => {
        console.log(error);
        this.isCancelling = false;
        this.successFailMessage = this.$t('pages.commons.quotes.cancel_fail') as string;
        this.$modal.show('successFailModal');
      });
  }

  cancelSingleMovie() {
    if (this.quoteMovies?.[this.plannedDeleteIndex] === void 0) {
      return false;
    }

    this.axios
      .put(`/quote_movie/${this.quoteMovies[this.plannedDeleteIndex].uuid}`, { status: 8 })
      .then((result: any) => {
        if (result.status !== 200) {
          this.successFailMessage = '見積もり依頼のキャンセルに失敗しました。';
          this.$modal.show('successFailModal');
          this.plannedDeleteIndex = -1;
          return false;
        }
        this.successFailMessage = '見積もり依頼のキャンセルに成功しました。';
        this.$modal.show('successFailModal');
        this.plannedDeleteIndex = -1;
        this.loadQuote();
      })
      .catch((error: any) => {
        this.successFailMessage = '見積もり依頼のキャンセルに失敗しました。';
        this.$modal.show('successFailModal');
        this.plannedDeleteIndex = -1;
      });
  }
  getMovieFormat(quoteMovieFormats: any, formatType: string) {
    if (!quoteMovieFormats || formatType in quoteMovieFormats == false || this.isQuoteSet) {
      return null;
    }
    return quoteMovieFormats[formatType];
  }
  validUntilToString(qm: QuoteMovie) {
    if (qm.status <= 2 || this.isQuoteSet) {
      return '';
    }
    return this.$t('pages.commons.quotes.valid_until') + ` ${(this as any).getDateString(qm.valid_until, true)}`;
  }
  private tmpIndex;
  number = -1; // ゴミ箱選択時の値一時保存
  planDelete(index: number) {
    if (this.plannedDeleteIndex == -1) {
      // this.plannedDeleteIndex = index; // ココで入れちゃうとモーダルキャンセルした時ゴミ箱から開けなくなる
      this.tmpIndex = index;
      this.$modal.show('checkDelete');
    }
  }

  cancelOrDeleteQuote() {
    //plannedDeleteIndex should be set
    if (this.tmpIndex >= 0 && this.plannedDeleteIndex === -1) {
      // モーダルキャンセル対策
      this.plannedDeleteIndex = this.tmpIndex;
      this.tmpIndex = -1;
    }
    this.$modal.hide('checkDelete');
    if (this.plannedDeleteIndex === -1 || (this.plannedDeleteIndex !== -1 && this.quoteMovies.length === 1)) {
      if (this.quote.status < 2) {
        //remove quote
        this.deleteQuote();
      } else {
        //cancel all
        this.cancelMovies();
      }
    } else {
      if (this.quote.status < 2) {
        //delete single
        this.deleteSingleMovie();
      } else {
        //cancel single
        this.cancelSingleMovie();
      }
    }
    this.plannedDeleteIndex = -1;
  }

  deleteSingleMovie() {
    if (!this.displayTrash) {
      return false;
    }
    if (this.quoteMovies?.[this.plannedDeleteIndex] === void 0) {
      return false;
    }

    this.axios
      .delete(`/quote_movie/${this.quoteMovies[this.plannedDeleteIndex].uuid}`)
      .then((responses) => {
        if (responses.status !== 200) {
          this.successFailMessage = '見積もり依頼の削除に失敗しました。';
          this.$modal.show('successFailModal');
          this.plannedDeleteIndex = -1;
          return false;
        }

        this.successFailMessage = '見積もり依頼の削除に成功しました。';
        this.plannedDeleteIndex = -1;
        this.$modal.show('successFailModal');
        if (this.quoteMovies.length === 1) {
          this.$router.push({ path: '/vod/quotes' });
        } else {
          this.loadQuote();
        }
      })
      .catch((error) => {
        this.successFailMessage = '見積もり依頼の削除に失敗しました。';
        this.plannedDeleteIndex = -1;
        this.$modal.show('successFailModal');
        console.log(error);
      });
  }

  deleteQuote() {
    if (!this.displayTrash) {
      return false;
    }
    this.axios
      .delete(`/quote/${this.quote.uuid}`)
      .then((response: any) => {
        if (response.status !== 200) {
          this.successFailMessage = '見積もり依頼の削除に失敗しました。';
          this.$modal.show('successFailModal');
          return false;
        }

        this.successFailMessage = '見積もり依頼の削除に成功しました。';
        this.$modal.show('successFailModal');
        this.$router.push({ path: '/vod/quotes' });
      })
      .catch((error: any) => {
        this.successFailMessage = '見積もり依頼の削除に失敗しました。';
        this.$modal.show('successFailModal');
        return false;
      });
  }
}
